module.exports = __webpack_public_path__ + "img/date.0f89d4b.webp";